// src/components/forms/TemplateForm.jsx
import React, { useState, useEffect } from 'react';
import { X, Save, Loader2 } from 'lucide-react';
import Button from '../common/Button';
import Modal from '../common/Modal';
import EnhancedTemplateEditor from '../../pages/templates/components/EnhancedTemplateEditor';

const TemplateForm = ({
  template = null,
  isOpen,
  onClose,
  onSubmit,
  loading = false
}) => {
  const [isSaving, setIsSaving] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  // Handle save from the EnhancedTemplateEditor
  const handleSave = async (templateData) => {
    setIsSaving(true);
    try {
      await onSubmit(templateData);
      setHasUnsavedChanges(false);
      onClose();
    } catch (error) {
      console.error('Error saving template:', error);
      // Error handling is done in the parent component
    } finally {
      setIsSaving(false);
    }
  };

  // Handle template changes to track unsaved changes
  const handleTemplateChange = (name, content) => {
    const nameChanged = name !== (template?.name || '');
    const contentChanged = content !== (template?.content || '');
    setHasUnsavedChanges(nameChanged || contentChanged);
  };

  // Handle modal close with unsaved changes warning
  const handleClose = () => {
    if (hasUnsavedChanges) {
      if (window.confirm('Aveți modificări nesalvate. Sunteți sigur că doriți să închideți?')) {
        setHasUnsavedChanges(false);
        onClose();
      }
    } else {
      onClose();
    }
  };

  // Reset unsaved changes when modal opens/closes
  useEffect(() => {
    if (isOpen) {
      setHasUnsavedChanges(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black bg-opacity-50" onClick={handleClose}></div>
      <div className="relative bg-white rounded-lg shadow-xl w-full h-full max-w-[98vw] max-h-[98vh] mx-4 flex flex-col">
        {/* Modal Content - Full height for editor */}
        <div className="flex-1 overflow-hidden">
          <EnhancedTemplateEditor
            templateId={template?.id || null}
            initialTemplate={template ? {
              name: template.name || '',
              content: template.content || '',
              isActive: template.isActive !== false
            } : null}
            onSave={handleSave}
            onCancel={handleClose}
            onChange={handleTemplateChange}
            isSaving={isSaving || loading}
            isEditMode={!!template}
            isModal={true} // Add this prop to indicate it's in a modal
            hideHeader={false} // Show the header with save buttons
          />
        </div>
      </div>
    </div>
  );
};

export default TemplateForm;